module.exports = __webpack_public_path__ + "src/images/placeholder_default_landscape.svg";